module.exports = "/images/logo-bv-financeira-1536.png?b51df502693443a73802f2eabae038b8";